// extracted by mini-css-extract-plugin
export default {"completed":"progress-bar_completed__JC+Fp","root":"progress-bar_root__-poFT","darkTheme":"progress-bar_darkTheme__UbvJM"};